/* Katalog motoru — the one viewer of every Norm brand catalogue: MelomyPet, Rose Candy, Herbaclean and Lacinia on their
   Shopify stores, Tanura on tanura.com.tr. Alp, 2026-10-19: «aynı motoru aynı şeyi kullansınlar en sorunsuzunu, kodları
   aynı olsun». The source is ~/Developer/norm-shopify/katalog-motoru/viewer.js; every book carries an identical copy as
   assets/js/viewer.js, written and checked by katalog-motoru/sync.py. Never edit a copy: edit here, then sync.

   Modes:  index.html                     → spread viewer (one page at a time on a narrow screen)
           index.html?print=digital       → 210 × 210 mm pages, screen images                       (dijital PDF)
           index.html?print=press         → print images; 226 mm sheets with 3 mm bleed and crop marks, or the trimmed
                                             210 mm page when the book says press: 'trim'           (baskı PDF)
           &lang=xx                       → language pack assets/content/xx.js
           &autoprint=1                   → opens the browser's PDF dialog once everything is loaded
   Deep link: #p=12 opens the spread that holds page 12.

   The book describes itself in window.KATALOG (assets/js/katalog.js, written by sync.py from the book's katalog.json;
   README.md lists the fields). On a site,
   the page around the book sets window.<KEY>_SITE = { lang, content, files, pdf, alt[, fonts] }: the site's language
   wins, the files come from the site, and «PDF indir» downloads that language's prebuilt PDF at once. */
(function () {
  const SCREEN = { imgBase: 'assets/img/lo', imgExt: 'webp' };
  const C = Object.assign({ langs: ['tr'], press: 'bleed', rtl: [], scriptFonts: {}, hash: ['VERSION', 'content'],
    images: { screen: SCREEN, digital: SCREEN, press: { imgBase: 'assets/img/hi', imgExt: 'png' } } }, window.KATALOG);
  const B = window[C.ns];                              // the book: content, buildPages(lang), VERSION, products…
  const UP = C.key.toUpperCase();
  const q = new URLSearchParams(location.search);
  const PRINT = q.get('print');                        // null | 'digital' | 'press'
  const SITE = window[`${UP}_SITE`] || null;
  const BUILT = window[`${UP}_PDF`] || null;           // local PDF builds: { lang: { digital|press: { file, hash } } }
  /* the languages of the book: on a site, those it was published in; here, those with a content file */
  const LANGS = SITE && SITE.content ? Object.keys(SITE.content) : C.langs;
  let lang = ((SITE && SITE.lang) || q.get('lang') || localGet(`${C.key}-lang`) || LANGS[0]).toLowerCase();
  if (!LANGS.includes(lang)) lang = LANGS[0];

  Object.assign(B, C.images[PRINT === 'press' ? 'press' : PRINT ? 'digital' : 'screen']);   /* which picture set the pages use */
  if (SITE && SITE.files) B.imgURL = (path) => SITE.files[path] || '';

  function localGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function localSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  const $ = (s, r = document) => r.querySelector(s);
  const T = () => B.content[lang];

  /* In a frame of a site page (tanura.com.tr: the book under the site's own header, Alp: «katalog açınca header gitti»)
     the page's own address carries #p=…, so a shared link opens that page, and the frame takes the screen's height below
     the header, which changes with the screen width. Anywhere else the book is its own window. */
  const HOST = (() => {
    try { return SITE && window.top !== window && window.top.location.origin === location.origin ? window.top : window; } catch (e) { return window; }
  })();
  function fitFrame() {
    const f = window.frameElement;
    if (!f) return;
    const top = f.getBoundingClientRect().top + HOST.scrollY;
    f.style.height = `${Math.max(360, Math.round(HOST.innerHeight - top))}px`;
  }
  if (HOST !== window) { fitFrame(); HOST.addEventListener('resize', fitFrame); }

  /* content fingerprint: the PDF build stores it, the download button compares it. KATALOG.hash names what goes in, in
     order ('content' is the language's text); a book keeps its list, or its built PDFs no longer match. */
  B.hash = function (l = lang) {
    const s = JSON.stringify(C.hash.map((k) => (k === 'content' ? B.content[l] : B[k])));
    let h = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
    return (h >>> 0).toString(16).padStart(8, '0');
  };

  function loadLang(l) {
    const text = new Promise((res, rej) => {
      if (B.content && B.content[l]) return res();
      const s = document.createElement('script'); s.src = SITE ? SITE.content[l] : `assets/content/${l}.js`; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
    /* letters the book's faces lack come from a companion face, loaded only for its languages (Tanura: ru, ar) */
    const script = C.scriptFonts[l];
    const fonts = !script || document.getElementById(`fonts-${script}`) ? null : new Promise((res) => {
      const k = document.createElement('link'); k.id = `fonts-${script}`; k.rel = 'stylesheet';
      k.href = SITE && SITE.fonts ? SITE.fonts[script] : `assets/css/fonts-${script}.css`; k.onload = k.onerror = res; document.head.appendChild(k);
    });
    return Promise.all([text, fonts]);
  }

  /* Right-to-left languages keep the book's layout and page order (spread photos span two pages); every text with
     their letters runs right to left, so punctuation, numbers and Latin product names fall in order, and aligns to the
     right of its box. A Latin name or number inside it keeps its own order in a <bdi>: «SPF 50+» would print «+SPF 50». */
  const RTL = C.rtl.includes(lang);
  const AR = /[֐-׿؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
  const LATIN_RUN = /[A-Za-z0-9À-ɏ][A-Za-z0-9À-ɏ₀-₉ .,:'’&/+™®°%·–-]*[A-Za-z0-9À-ɏ₀-₉+™®%]|[A-Za-z0-9]/g;
  function textBox(el) {                               /* the block that lays a text out; a flex or grid row keeps its order */
    for (let e = el; e; e = e.parentElement) {
      const d = getComputedStyle(e).display;
      if (d === 'inline' || d === 'contents') continue;
      return /flex|grid/.test(d) ? null : e;
    }
    return null;
  }
  function rtlText(root) {
    if (!RTL || !root) return;
    const texts = [];
    const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let t = tw.nextNode(); t; t = tw.nextNode()) texts.push(t);
    texts.forEach((t) => {
      if (!AR.test(t.textContent)) return;
      const box = textBox(t.parentElement);
      if (box) box.setAttribute('dir', 'rtl');
    });
    texts.forEach((t) => {
      const el = t.parentElement, box = el && el.closest('[dir]');
      if (!box || box.getAttribute('dir') !== 'rtl' || el.closest('bdi') || !/[A-Za-z0-9]/.test(t.textContent)) return;
      const s = t.textContent, frag = document.createDocumentFragment();
      let at = 0;
      for (const m of s.matchAll(LATIN_RUN)) {
        if (m.index > at) frag.append(s.slice(at, m.index));
        const iso = document.createElement('bdi'); iso.textContent = m[0]; frag.append(iso);
        at = m.index + m[0].length;
      }
      if (at < s.length) frag.append(s.slice(at));
      t.replaceWith(frag);
    });
  }

  /* A book whose pages are already in the document names their container in KATALOG.pool (Snappax: its build writes
     every page as HTML, which stays in the document for readers and search engines); any other book composes its pages
     with buildPages(lang). */
  const POOL = C.pool ? document.querySelector(C.pool) : null;
  const sourcePages = (l) => (POOL ? [...POOL.children].map((n) => n.outerHTML) : B.buildPages(l));

  /* a picture that names its print source (data-hi) uses it on paper, never the small screen file of its srcset */
  function paperPictures(root) {
    root.querySelectorAll('img').forEach((im) => {
      im.loading = 'eager';
      if (!im.dataset.hi) return;
      const pic = im.closest('picture'); if (pic) pic.querySelectorAll('source').forEach((x) => x.remove());
      im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = im.dataset.hi;
    });
  }

  function whenReady(root) {
    const imgs = [...root.querySelectorAll('img')];
    const bgs = [...root.querySelectorAll('[style*="background-image"]')].map((el) => (el.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/) || [])[1]).filter(Boolean);
    const ps = imgs.map((im) => (im.complete ? (im.decode ? im.decode().catch(() => {}) : 0) : new Promise((r) => { im.onload = im.onerror = r; })));
    bgs.forEach((u) => ps.push(new Promise((r) => { const i = new Image(); i.onload = i.onerror = r; i.src = u; })));
    void root.offsetHeight;                            /* lay the pages out first, so the faces they need are already loading */
    return Promise.all([document.fonts ? document.fonts.ready : 0, ...ps]);
  }

  /* ---------------- print / PDF layout ---------------- */
  function renderPrint(kind) {
    document.documentElement.classList.add('print-mode');
    const bleed = kind === 'press' && C.press !== 'trim';
    $('#page-size').textContent = `@page { size: ${bleed ? 226 : 210}mm ${bleed ? 226 : 210}mm; margin: 0; }`;
    document.documentElement.lang = T().meta.lang;     /* before the pages: their capitals follow it («i» → «İ» in Turkish only) */
    const html = sourcePages(lang);
    if (POOL) POOL.remove();                           /* its pages are on the sheets now */
    const root = $('#print-root');
    root.innerHTML = html.map((p, i) => (bleed
      ? `<div class="sheet press"><div class="bleedbox">${p}</div>${marks()}<p class="slug">${T().meta.docTitle} · ${lang.toUpperCase()} · ${i + 1}/${html.length}</p></div>`
      : `<div class="sheet digital">${p}</div>`)).join('');
    rtlText(root); paperPictures(root);
    document.title = `${T().meta.docTitle} · ${kind === 'press' ? T().meta.press : T().meta.digital}`;
    whenReady(root).then(() => {
      document.documentElement.dataset.ready = '1';
      if (q.get('autoprint')) setTimeout(() => window.print(), 300);
    });
  }
  function marks() {
    /* crop marks: trim box at 8 mm, marks start 3 mm outside the trim (beyond bleed), 5 mm long */
    const L = [];
    for (const t of [8, 218]) L.push(`M0 ${t}H5`, `M221 ${t}H226`, `M${t} 0V5`, `M${t} 221V226`);
    return `<svg class="marks" viewBox="0 0 226 226" aria-hidden="true"><path d="${L.join('')}" stroke="#000" stroke-width="0.12" fill="none"/></svg>`;
  }

  /* ---------------- viewer ---------------- */
  let pages = [];          // HTML strings
  let nodes = [];          // section elements
  let spreads = [];        // [[left, right] page numbers or null]
  let cur = 0, busy = false, single = false;
  let side = 'r';          // which page of the spread a narrow screen shows

  function buildSpreads() {
    spreads = [[null, 1]];   /* the cover alone, then pairs; with an even page count the back cover stands alone on the left */
    for (let n = 2; n < pages.length; n += 2) spreads.push([n, n + 1 <= pages.length ? n + 1 : null]);
    if (pages.length % 2 === 0) spreads.push([pages.length, null]);
  }
  const spreadOf = (n) => spreads.findIndex((s) => s.includes(n));
  const hashPage = () => parseInt((HOST.location.hash.match(/p=(\d+)/) || [])[1], 10);

  function renderViewer() {
    const t = T();
    document.documentElement.lang = t.meta.lang;
    if (!SITE) {                                       /* on a site, the page around the book has the title and meta tags */
      document.title = t.meta.docTitle;
      const desc = $('meta[name="description"]'); if (desc) desc.content = `${t.meta.docTitle} — ${t.meta.description}.`;
    }
    pages = sourcePages(lang);
    if (POOL) { rtlText(POOL); nodes = [...POOL.children]; }
    else {
      const pool = document.createElement('div');
      pool.innerHTML = pages.map((h) => h.replace(/<img\b([^>]*?)\ssrc="/g, '<img$1 data-src="')).join('');
      if (RTL) { pool.hidden = true; document.body.appendChild(pool); rtlText(pool); pool.remove(); }   /* styles need the document */
      nodes = [...pool.children];
    }
    buildSpreads();
    chrome();
    const fromHash = hashPage();
    cur = fromHash ? Math.max(0, spreadOf(fromHash)) : 0;
    side = fromHash && spreads[cur][0] === fromHash ? 'l' : (spreads[cur][1] ? 'r' : 'l');
    layout(); show(cur);
    settle(decodePages(spreads[cur]), 4000).then(loadRest);
    window.addEventListener('resize', () => { layout(); show(cur); });
    HOST.addEventListener('hashchange', () => {
      const n = hashPage();
      if (n && !(single ? shownSingle() === n : spreads[cur].includes(n))) goPage(n);
    });
    bindInput();
    if (HOST !== window) window.focus();               /* the arrow keys turn pages at once, as on a page of its own */
  }

  /* the bar's and the dock's icons: the same in every book */
  const svg = (inner, w = 1.6) => `<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
  const ICON = {
    prev: svg('<path d="M14.5 6 8.5 12l6 6"/>'),
    next: svg('<path d="m9.5 6 6 6-6 6"/>'),
    grid: svg('<rect x="4" y="4" width="6.5" height="6.5" rx="1.4"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.4"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.4"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.4"/>'),
    down: svg('<path d="M12 4.5v10.5M7.5 11 12 15.5 16.5 11M5 19.5h14"/>'),
    screen: svg('<rect x="3.5" y="5" width="17" height="11" rx="1.5"/><path d="M9 19.5h6M12 16v3.5"/>'),
    press: svg('<path d="M7 2v4M2 7h4M17 2v4M22 7h-4M7 22v-4M2 17h4M17 22v-4M22 17h-4"/><rect x="7" y="7" width="10" height="10"/>', 1.3),
  };
  function chrome() {
    const t = T();
    $('#lbl-title').textContent = `${t.meta.bookTitle} · ${t.meta.edition.replace(/^\D+/, '')}`;   /* «Bakım Kitabı · 2026» */
    $('#btn-pdf').innerHTML = `${ICON.down}<span>${t.ui.pdf}</span>`;
    $('#btn-prev').innerHTML = ICON.prev;
    $('#btn-next').innerHTML = ICON.next;
    $('#btn-grid').innerHTML = ICON.grid;
    [['#btn-prev', t.ui.prev], ['#btn-next', t.ui.next], ['#btn-grid', t.ui.pages]].forEach(([s, v]) => {
      const el = $(s); if (el && v) { el.title = v; el.setAttribute('aria-label', v); }
    });
    $('#hint').textContent = t.ui.keyboard || '';
    const box = $('#lang'), many = LANGS.length > 1 && (!SITE || SITE.alt);
    box.hidden = !many;
    if (t.ui.language || t.ui.lang) box.setAttribute('aria-label', t.ui.language || t.ui.lang);
    box.innerHTML = !many ? '' : LANGS.map((l) => (SITE
      ? `<a href="${SITE.alt[l]}" hreflang="${l}" lang="${l}"${HOST !== window ? ' target="_top"' : ''}${l === lang ? ' aria-current="page"' : ''}>${l.toUpperCase()}</a>`
      : `<button data-lang="${l}" aria-pressed="${l === lang}">${l.toUpperCase()}</button>`)).join('');
    $('#pdf-menu').innerHTML = `
      <button data-pdf="digital"><span class="mi">${ICON.screen}</span><div><b>${t.ui.pdfDigital}</b><span>${t.ui.pdfDigitalNote}</span></div></button>
      <button data-pdf="press"><span class="mi l">${ICON.press}</span><div><b>${t.ui.pdfPrint}</b><span>${t.ui.pdfPrintNote}</span></div></button>`;
    ['.bar', '#hint', '#pdf-menu'].forEach((sel) => rtlText($(sel)));
  }

  function layout() {
    const stage = $('#stage');
    const W = stage.clientWidth - 48, H = stage.clientHeight - 24;
    const mm = 96 / 25.4;
    single = W / H < 1.15 || W < 700;
    /* One page's side in CSS px, in whole device pixels. The pages are scaled into it (viewer.css), not the book: a scaled
       book made the turning leaf a resampled copy, soft the moment it lifted and sharp again when it landed. */
    const dpr = window.devicePixelRatio || 1;
    const pg = Math.floor(Math.min(single ? W : W / 2, H) * dpr) / dpr;
    const book = $('#book'), wrap = $('#book-wrap');
    book.classList.toggle('single', single);
    book.style.setProperty('--pg', `${pg}px`); book.style.setProperty('--s', pg / (210 * mm));
    wrap.style.width = `${single ? pg : 2 * pg}px`; wrap.style.height = `${pg}px`;
  }

  /* A picture that is painted for the first time while a leaf turns is decoded mid-animation and flashes empty (worse on
     a site, where it may still be downloading). Decode the pages of a spread before they are shown, keep the neighbours
     of the current spread decoded… */
  const decoded = new WeakSet();
  function decodePages(list) {
    const ps = [];
    list.filter(Boolean).forEach((n) => nodes[n - 1].querySelectorAll('img').forEach((im) => {
      if (im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); }
      if (im.loading === 'lazy') im.loading = 'eager';   /* a lazy picture out of view would never start */
      if (decoded.has(im)) return;
      ps.push((im.decode ? im.decode() : Promise.resolve()).then(() => decoded.add(im), () => {}));
    }));
    return Promise.all(ps);
  }
  function warm(i) {   /* the current spread first, then the next two and the previous one */
    [i, i + 1, i - 1, i + 2].filter((k) => k >= 0 && k < spreads.length).forEach((k) => decodePages(spreads[k]));
  }
  const settle = (p, ms) => Promise.race([p, new Promise((r) => setTimeout(r, ms))]);
  /* …and then the rest of the book in reading order, one spread at a time, so a reader who turns fast never meets a
     picture still on its way: a new file's first request can take a second or two, longer than a turn waits. One spread
     at a time keeps the opening pages from sharing the line with every other picture. */
  let rest = 0;
  function loadRest() {
    const started = (sp) => sp.every((n) => !n || !nodes[n - 1].querySelector('img[data-src], img[loading="lazy"]'));
    while (rest < spreads.length && started(spreads[rest])) rest++;
    if (rest >= spreads.length) return;
    settle(decodePages(spreads[rest++]), 8000).then(() => setTimeout(loadRest, 30));
  }
  function place(slot, n) {
    const el = n ? nodes[n - 1] : null;
    if (el && el.parentNode === slot && slot.childElementCount === 1) return;   /* re-attaching a page repaints it */
    slot.replaceChildren();
    if (el) slot.appendChild(el);
  }

  const shownSingle = () => { const sp = spreads[cur]; return side === 'l' ? (sp[0] || sp[1]) : (sp[1] || sp[0]); };
  const wanted = (i) => (single ? [null, shownSingle()] : spreads[i]);   /* what the two slots should hold */
  function show(i) {
    const book = $('#book');
    [...book.querySelectorAll(':scope > .slot')].slice(0, -2).forEach((el) => el.remove());   /* a cross() cut short */
    const L = book.querySelector('.slot.l'), R = book.querySelector('.slot.r');
    const [l, r] = wanted(i);
    place(L, l); place(R, r);
    updateUI();
    warm(i);
  }

  /* A page change without a turning leaf (a phone, a narrow window, a jump from the grid, Home/End or a deep link): the
     new pages fade in on their own slots OVER the old ones, which leave only once the new ones are fully opaque, so the
     book is never empty for a frame (fading the whole book in from nothing made every page blink on a phone). */
  function cross(i) {
    const book = $('#book');
    const old = [...book.querySelectorAll(':scope > .slot')];
    const want = wanted(i);
    if (want.every((n, k) => (n ? nodes[n - 1].parentNode === old[k] : !old[k].firstChild))) { updateUI(); return; }
    busy = true;
    settle(decodePages(want), TURN_WAIT).then(() => {
      const fresh = ['l', 'r'].map((s, k) => {
        const el = document.createElement('div'); el.className = `slot ${s}`;
        if (want[k]) el.appendChild(nodes[want[k] - 1]);
        book.appendChild(el);
        return el;
      });
      updateUI(); warm(i);
      const done = () => { old.forEach((el) => el.remove()); busy = false; };
      if (reduce) { requestAnimationFrame(() => requestAnimationFrame(done)); return; }
      const anims = fresh.map((el) => el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out', fill: 'forwards' }));
      anims[0].onfinish = () => requestAnimationFrame(done);
    });
  }

  function updateUI() {
    const t = T(), sp = spreads[cur];
    const nums = single ? [shownSingle()] : sp.filter(Boolean);
    const label = nums[0] === 1 ? t.ui.cover : nums[0] === pages.length && (single || !sp[1]) ? t.ui.backCover : nums.join('–');
    const pw = t.ui.pagesWord || t.meta.pagesWord;      /* a site's own labels (SITE.ui) may name the pages in its language */
    const word = lang === 'de' ? pw : pw.toLocaleLowerCase(t.meta.locale);   /* a German noun keeps its capital */
    $('#pos').innerHTML = `${label}<small>${pages.length} ${word}</small>`;
    rtlText($('#pos'));
    $('#btn-prev').disabled = single ? nums[0] === 1 : cur === 0;
    $('#btn-next').disabled = single ? nums[0] === pages.length : cur === spreads.length - 1;
    $('#stage').classList.toggle('at-start', $('#btn-prev').disabled);
    $('#stage').classList.toggle('at-end', $('#btn-next').disabled);
    HOST.history.replaceState(HOST.history.state, '', `#p=${nums[0]}`);   /* a host page's own state (its router) is kept */
  }

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* how long a change waits for the next pages' pictures. Where they are ready (almost always, see loadRest) it turns at
     once; on a slow line it waits rather than show a picture popping in (450 ms let 18 of 64 frames show a picture
     loading on a 4 Mbit/s line, melomypet.com 2026-10-16). */
  const TURN_WAIT = 1500;
  function go(target) {
    if (busy || target < 0 || target >= spreads.length || target === cur) return;
    if (single || reduce || Math.abs(target - cur) > 1) { cur = target; cross(cur); return; }
    busy = true;
    settle(decodePages(spreads[target].concat(spreads[cur])), TURN_WAIT).then(() => flip(target));
  }

  /* A turn is two leaves, each holding its page the right way round: the lifting page turns away on its own leaf, and the
     landing page comes down on a second one that starts folded over onto the first. Each shows only on its own half of
     the turn: visibility switches at exactly 90° (offset .5 under the rotation's own easing), so each leaf is flat and
     unturned at the frame where it meets a still page, and is drawn at full resolution there. A single leaf whose back
     face carried the landing page came out soft on a Retina screen, and WebKit does not hide a turned-away face's inner
     layers, so its shade and pictures showed through (2026-10-19: Herbaclean, Rose Candy, MelomyPet, Lacinia). */
  function flip(target) {
    const fwd = target > cur, book = $('#book');
    const L = book.querySelector('.slot.l'), R = book.querySelector('.slot.r');
    const now = spreads[cur], next = spreads[target], dur = 760;
    const timing = { duration: dur, easing: 'cubic-bezier(.62,.04,.3,1)', fill: 'forwards' };
    const leaf = (right, n) => {
      const el = document.createElement('div'); el.className = `leaf ${right ? 'fwd' : 'back'}`; el.style.setProperty('--dur', `${dur}ms`);
      const face = document.createElement('div'); face.className = 'face';
      if (n) face.appendChild(nodes[n - 1]);
      el.appendChild(face);
      return el;
    };
    const up = leaf(fwd, fwd ? now[1] : now[0]), down = leaf(!fwd, fwd ? next[0] : next[1]);
    const folded = `rotateY(${fwd ? 180 : -180}deg)`;
    down.style.transform = folded; down.style.visibility = 'hidden';
    if (fwd) place(R, next[1]); else place(L, next[0]);
    book.append(up, down);
    const half = (a, b) => [{ visibility: a }, { visibility: a, offset: 0.5 }, { visibility: b, offset: 0.5 }, { visibility: b }];
    requestAnimationFrame(() => requestAnimationFrame(() => {
      up.animate([{ transform: 'rotateY(0deg)' }, { transform: `rotateY(${fwd ? -180 : 180}deg)` }], timing);
      up.animate(half('visible', 'hidden'), timing);
      down.animate(half('hidden', 'visible'), timing);
      const anim = down.animate([{ transform: folded }, { transform: 'rotateY(0deg)' }], timing);
      up.classList.add('go');
      anim.onfinish = () => {
        cur = target;
        place(L, next[0]); place(R, next[1]);
        up.remove(); down.remove();
        busy = false; updateUI(); warm(cur);
      };
    }));
  }

  function next() { if (single) return singleStep(1); go(cur + 1); }
  function prev() { if (single) return singleStep(-1); go(cur - 1); }
  function singleStep(d) {   /* one page at a time, across spreads */
    if (busy) return;
    const sp = spreads[cur];
    if (d > 0) {
      if (side === 'l' && sp[1]) side = 'r';
      else if (cur < spreads.length - 1) { cur++; side = spreads[cur][0] ? 'l' : 'r'; } else return;
    } else if (side === 'r' && sp[0]) side = 'l';
    else if (cur > 0) { cur--; side = spreads[cur][1] ? 'r' : 'l'; } else return;
    cross(cur);
  }
  function goPage(n) {
    const i = spreadOf(n); if (i < 0) return;
    if (single) { if (busy) return; side = spreads[i][0] === n ? 'l' : 'r'; cur = i; cross(cur); return; }
    go(i);
  }

  function bindInput() {
    $('#btn-next').onclick = next; $('#btn-prev').onclick = prev;
    $('#btn-grid').onclick = openGrid;
    $('#grid-close').onclick = () => { $('#grid').hidden = true; };
    const onKey = (e) => {
      if (e.target.closest && e.target.closest('input,textarea')) return;
      if (['ArrowRight', 'PageDown', ' '].includes(e.key)) { e.preventDefault(); next(); }
      else if (['ArrowLeft', 'PageUp'].includes(e.key)) { e.preventDefault(); prev(); }
      else if (e.key === 'Home') goPage(1);
      else if (e.key === 'End') goPage(pages.length);
      else if (e.key === 'Escape') { $('#grid').hidden = true; $('#pdf-menu').hidden = true; }
      else if (e.key.toLowerCase() === 'g') { $('#grid').hidden ? openGrid() : ($('#grid').hidden = true); }
    };
    document.addEventListener('keydown', onKey);
    /* in a site page's frame, keys pressed while the page around it has the focus (after its consent banner, say) turn
       pages too; never those meant for a control of that page */
    if (HOST !== window) HOST.document.addEventListener('keydown', (e) => {
      const t = e.target;
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || !t.closest || t.closest('a,button,input,select,textarea,[contenteditable],[role="dialog"],dialog')) return;
      onKey(e);
    });
    /* A click on the right half of the stage turns forward, on the left half back, the margins beside the book included.
       The pages hold no links: a page reference under the pointer used to take a turn somewhere else (Alp, 2026-10-19:
       «linkli olduğu için basarken rastgele sayfaya atlıyor … gerek yok linke»). */
    $('#stage').addEventListener('click', (e) => {
      if (e.target.closest('a,button')) return;
      const r = $('#stage').getBoundingClientRect();
      (e.clientX - r.left) > r.width / 2 ? next() : prev();
    });
    let sx = null;
    $('#stage').addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    $('#stage').addEventListener('touchend', (e) => {
      if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) (dx < 0 ? next() : prev());
    });
    $('#btn-pdf').onclick = (e) => { e.stopPropagation(); if (SITE) { downloadPdf('digital'); return; } $('#pdf-menu').hidden = !$('#pdf-menu').hidden; };
    document.addEventListener('click', (e) => { if (!e.target.closest('#pdf-menu,#btn-pdf')) $('#pdf-menu').hidden = true; });
    $('#pdf-menu').addEventListener('click', (e) => { const b = e.target.closest('[data-pdf]'); if (b) { $('#pdf-menu').hidden = true; downloadPdf(b.dataset.pdf); } });
    $('#lang').addEventListener('click', (e) => {
      const b = e.target.closest('[data-lang]'); if (!b || b.dataset.lang === lang) return;
      localSet(`${C.key}-lang`, b.dataset.lang);
      location.search = `?lang=${b.dataset.lang}`;
    });
  }

  function openGrid() {
    const t = T();
    const list = $('#grid-list');
    $('#grid-title').textContent = t.ui.pages;
    $('#grid-close').textContent = t.ui.close;
    rtlText($('.grid-head'));
    if (!list.childElementCount) {
      list.innerHTML = spreads.map((sp, i) => {
        const cap = sp.filter(Boolean).join('–');
        return `<div class="thumb" data-i="${i}"><div class="tb"><div class="tb-in">${sp.map((n) => `<div>${n ? pages[n - 1] : ''}</div>`).join('')}</div></div><p class="cap">${sp[0] === null ? t.ui.cover : sp[1] === null ? t.ui.backCover : cap}</p></div>`;
      }).join('');
      rtlText(list);
      list.addEventListener('click', (e) => {
        const th = e.target.closest('.thumb'); if (!th) return;
        $('#grid').hidden = true; const i = +th.dataset.i; if (i !== cur && !busy) { cur = i; side = spreads[i][1] ? 'r' : 'l'; cross(cur); }
      });
    }
    $('#grid').hidden = false;
    requestAnimationFrame(() => {
      list.querySelectorAll('.thumb').forEach((th) => {
        const w = th.querySelector('.tb').clientWidth; const s = w / (420 * 96 / 25.4);
        th.querySelector('.tb-in').style.transform = `scale(${s})`;
        th.classList.toggle('cur', +th.dataset.i === cur);
      });
    });
  }

  /* ---------------- PDF ---------------- */
  function save(url, name) {
    const a = document.createElement('a');
    a.href = url; a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
  }
  function downloadPdf(kind) {
    const t = T();
    const f = SITE && SITE.pdf && SITE.pdf[lang];
    if (f) { save(f.url, f.name); return; }            /* a site offers the screen PDF of its own language */
    const built = BUILT && BUILT[lang] && BUILT[lang][kind];
    if (built && built.hash === B.hash()) { save(built.file, built.file.split('/').pop()); return; }
    /* content changed since the last build (or no build yet): convert live with the browser's PDF engine */
    toast(`${t.ui.pdfPreparing} ${t.ui.pdfLiveHint}`);
    const url = `${location.pathname}?print=${kind}&lang=${lang}&autoprint=1`;
    const w = window.open(url, '_blank');
    if (!w) location.href = url;
  }
  let toastT;
  function toast(msg) {
    const el = $('#toast'); el.textContent = msg; el.hidden = false; rtlText(el);
    clearTimeout(toastT); toastT = setTimeout(() => { el.hidden = true; }, 6000);
  }

  /* ---------------- boot ---------------- */
  /* A site may publish a book in fewer languages than the site has: its page then shows the book's first language with
     the buttons in the page's own (SITE.ui; Lacinia's /en page, until an English edition is approved). */
  loadLang(lang).then(() => {
    if (SITE && SITE.ui) Object.assign(B.content[lang].ui, SITE.ui);
    return PRINT ? renderPrint(PRINT === 'press' ? 'press' : 'digital') : renderViewer();
  });
})();
